import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';

/**
 * Listens for the `swUpdateAvailable` event emitted by serviceWorkerRegistration.ts
 * and shows a persistent toast "Доступна новая версия → Обновить".
 *
 * Clicking the toast posts SKIP_WAITING to the new SW. The `controllerchange`
 * handler in serviceWorkerRegistration.ts then reloads the page once, so the
 * fresh bundle takes over without manual hard-refresh.
 */
const PWAUpdatePrompt: React.FC = () => {
  useEffect(() => {
    const handler = (event: Event) => {
      const registration = (event as CustomEvent<ServiceWorkerRegistration>).detail;
      const waiting = registration?.waiting;
      if (!waiting) return;

      toast(
        (t) => (
          <div className="flex items-center gap-3">
            <span>Доступна новая версия GGDesk</span>
            <button
              onClick={() => {
                waiting.postMessage({ type: 'SKIP_WAITING' });
                toast.dismiss(t.id);
              }}
              className="px-3 py-1 rounded-md bg-primary text-primary-foreground text-sm font-semibold hover:opacity-90"
            >
              Обновить
            </button>
          </div>
        ),
        { duration: Infinity, id: 'sw-update-available' },
      );
    };

    window.addEventListener('swUpdateAvailable', handler);
    return () => window.removeEventListener('swUpdateAvailable', handler);
  }, []);

  return null;
};

export default PWAUpdatePrompt;
